import React from "react";

import { Auth } from "../../../context/admin/Authentication";

import Screen from "../../home/content/Screen";

import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";
import Detail from "./Details";

import { DoSeeDataProvider } from "../../../context/doSeeData/DoSeeDataContext";
import { CountryProvider } from "../../../context/country/countryContext/CountryContext";
import { PositionProvider } from "../../../context/position/PositionContext";

export const News = () => {
  return (
    <DoSeeDataProvider>
      <PositionProvider>
        <Auth
          children={
            <Screen
              component={<Overview />}
              title="News"
            />
          }
        />
      </PositionProvider>
    </DoSeeDataProvider>
  );
};

export const AddNews = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Add />}
              title="Add News"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const EditNews = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Edit />}
              title="Edit News"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const ViewNews = () => {
  return (
    <DoSeeDataProvider>
      <Auth
        children={
          <Screen
            component={<Detail />}
            title="News Details"
          />
        }
      />
    </DoSeeDataProvider>
  );
};
